import { Box } from '@mui/material';
import { DependenciesContentViewType } from '../../dependencies/types';
import { ListElementWrapper } from '../../shared/ListElementWrapper';
import { CardContent } from './CardContent';
import { NoResults } from '../../shared/NoResults';
import { useSelector } from 'react-redux';
import { selectDependenciesConfigurationItem } from '../../../../reducers/documentation/documentationReducer';
import { useDependencies } from '../../dependencies/hooks/useDependencies';
import { SalesforceItem, isFieldConfigurationItem } from '../../../parser/ParserTypes';
import { useMetadata } from '../../metadata/useMetadata';
import { humanizeDate } from '../../../helpers/humanizeDate';
import { Virtuoso } from 'react-virtuoso';
import { selectActiveDocumentationPageTab } from '../../../../reducers/documentation/documentationPageReducer';

interface CardListProps {
  list: SalesforceItem[];
  crmOrgId: string;
}

export const MetadataCards = ({ list, crmOrgId }: CardListProps) => {
  const selectedDependency = useSelector(selectDependenciesConfigurationItem);
  const firstHistoryItem = selectedDependency?.history?.[0];
  const { handleSetConfigurationItem } = useDependencies(crmOrgId);
  const { setMetadataElement } = useMetadata();
  const activeTab = useSelector(selectActiveDocumentationPageTab);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      {list.length ? (
        <Virtuoso
          style={{ height: '100%' }}
          data={list}
          itemContent={(_, item) => (
            <Box key={'wrapper_' + item.id}>
              <ListElementWrapper
                elementId={item.id}
                sx={{
                  minHeight: '64px',
                  pr: 0,
                  pl: 0,
                  pt: 1.5,
                  pb: 1.5,
                }}
                onWrapperClick={() => {
                  handleSetConfigurationItem({
                    id: item.id,
                    dependencyType: isFieldConfigurationItem(item) ? item.fieldType : '',
                    parentType: item.parentType,
                    name: item.name,
                    clearHistory: true,
                    contentType: DependenciesContentViewType.default,
                  });
                  setMetadataElement(item.id, activeTab ?? '', crmOrgId);
                }}
                isHighlighted={
                  firstHistoryItem?.id === item.id ||
                  (firstHistoryItem?.name === item.name &&
                    item.objectApiNames.includes(firstHistoryItem?.objectName ?? ''))
                }
                leftContent={
                  <CardContent
                    parentType={item.parentType}
                    label={item.label}
                    apiName={item.name}
                    date={humanizeDate({ dateOrTimestamp: item.updatedAt ?? '' })}
                    isActive={!!item.isActive}
                    dependencyType={isFieldConfigurationItem(item) ? item.fieldType : ''}
                  />
                }
              />
            </Box>
          )}
        />
      ) : (
        <Box pl={2}>
          <NoResults />
        </Box>
      )}
    </Box>
  );
};
